// TODO: Phase 4+ — add application-wide constants (pagination defaults, timeouts, etc.)

/** Default page size for paginated API responses */
export const DEFAULT_PAGE_SIZE = 25;

/** Version polling interval in milliseconds (5 minutes) */
export const VERSION_POLL_INTERVAL_MS = 5 * 60 * 1000;

/** Stale time for TanStack Query defaults in milliseconds (5 minutes) */
export const DEFAULT_STALE_TIME_MS = 5 * 60 * 1000;

/** Maximum total products a trial subsidiary may import across all runs. */
export const TRIAL_BATCH_SIZE_CAP = 500;

/** Lily's public privacy policy — linked from the login page (opens in a new tab). */
export const PRIVACY_POLICY_URL = 'https://www.lily.ai/privacy';

/** Google API Services User Data Policy — cited by the public homepage's Limited Use statement. */
export const GOOGLE_API_USER_DATA_POLICY_URL =
  'https://developers.google.com/terms/api-services-user-data-policy';
